import * as React from 'react'
import logUtil from 'utils/log'
import Flex from 'components/Flex'
import Loader from 'components/Loader'
import './index.css'

export default function PageLoader () {
  logUtil('PageLoader').debug('[start]')
  return (
    <Flex className='page-loader'>
      <Loader />
    </Flex>
  )
}
